import { useEffect } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { getPlayerTags } from 'js/hooks/user/server';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';
import * as Types from '../types';

export const useGetPlayerTags = () => {
    const dispatch = useDynamicReducerDispatch();
    const { documentGroups = [] } = useComponentConfig<Types.IIdenttManualComponentConfig>();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }

        const expectedPlayerTags = documentGroups.map(group => group.playerTag).filter(Boolean);

        if (!expectedPlayerTags.length) {
            dispatch(actions.setPlayerTags([]));
        }

        (async () => {
            try {
                const response = await getPlayerTags(expectedPlayerTags.join(','));
                const tags = response?.data?.tags || [];

                dispatch(actions.setPlayerTags(tags));
            } catch {
                dispatch(actions.setIsLoadingError(true));
            }
        })();
    }, [dispatch, documentGroups, isLoggedIn]);
};
